// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:07.347Z
// Property: Santa Fe Suites (ID: 6767906449167301)
// Collections: 2 floorplans (live), 17 photos, 46 POIs, 2 reviews, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167301",
  "property_external_id": "07p48t2",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/santa-fe-suites-santa-fe-nm/07p48t2/",
  "property_google_business_url": "https://www.google.com/maps/place/Santa+Fe+Suites/data=!4m2!3m1!1s0x0:0xd977162182d59593?sa=X&ved=2ahUKEwiWssPmis6TAxUL5MkDHXIALlcQ_BJ6BAgJEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52457036062",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "273SFS",
  "property_status": null,
  "property_slug": "santa-fe-suites",
  "property_name": "Santa Fe Suites",
  "property_website_url": "https://www.liveatsantafesuites.com/",
  "property_domain": "https://www.liveatsantafesuites.com/",
  "property_address": "3007 S St Francis Dr",
  "property_full_address": "3007 S St Francis Dr, Santa Fe, NM 87505",
  "property_address_1": "3007 S St Francis Dr",
  "property_address_2": null,
  "property_address_city": "Santa Fe",
  "property_address_state": "NM",
  "property_address_zip_full": null,
  "property_address_zip": "87505",
  "property_address_country": "US",
  "property_address_county": "Santa Fe County",
  "property_neighborhood_address": "Santa Fe",
  "property_address_latitude": "35.644563",
  "property_address_longitude": "-105.9553306",
  "property_email": "santafesuites.mgr@liveamc.com",
  "property_phone": "505-982-1154",
  "property_call_tracking_phone": "(505) 982-1154",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Santa Fe Suites, where comfort and convenience blend seamlessly. Choose from stylish studio or one-bedroom floor plans, complete with modern amenities like a poolside grill and free high-speed Wi-Fi. With beautiful parks and shopping just steps away, your vibrant lifestyle awaits. Secure your ideal home today!",
  "property_long_description": "**Discover Your Ideal Living Space at Santa Fe Suites**  \n\nWelcome to Santa Fe Suites, where modern comfort meets convenience in the heart of Santa Fe, NM. We offer an array of thoughtfully designed floor plans, including cozy studios and spacious one-bedroom apartments, ensuring you'll find the perfect space to call home. Our community caters to your every need with a variety of amenities designed for a vibrant lifestyle. Enjoy our newly renovated laundry facility and vast outdoor spaces, including a charming picnic area and grilling space for delightful weekend barbecues.\n\nSanta Fe Suites features convenient on-site management, seamless online resident services, and a pet-friendly atmosphere that lets you enjoy nature right at your doorstep. With gated access, a clubhouse for social gatherings, and ample outdoor seating, you’ll relish your new lifestyle. Wi-Fi is available community-wide, along with basic cable, enhancing your everyday living experience.\n\nResiding here means being just minutes away from popular spots like Plaza Entrada Shopping and Plaza Del Sol, as well as Santa Fe Community College. Enjoy easy access to Zia Road Rail Station and explore five parks within a three-mile radius. Our apartment features include stainless steel appliances, wood-inspired flooring, air conditioning, and high-speed Internet to keep you connected.\n\nIf you're ready to elevate your living experience, find your new home today! Browse our availability or schedule a tour to visit our inviting community – your perfect apartment awaits at Santa Fe Suites!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
    "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
    "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
    "width": 1280,
    "height": 854
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "123",
  "property_year_built": "1998",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.5609756097561",
  "property_admin_fee": "0",
  "property_application_fee": "0",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "150",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "100",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "No specific weight limits, pet rent, or maximum number of pets are provided.",
  "property_pet_policy_description": "We love your pets just as much as you do! Santa Fe Suites is a pet‑enthusiastic property, welcoming both dogs and cats. (No specific weight limits, pet rent, or maximum number of pets are provided.)",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.on-site.com/web/online_app3/484536/step/criteria",
  "property_resident_portal_url": "https://santafesuites.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.on-site.com/web/online_app3/484536/step/criteria",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-d4c2-74da-af2b-736da7eff252.webp",
  "property_primary_logo_media": {
    "alt_text": "Santa Fe Suites logo.",
    "public_id": "019d02d5-d4c2-74da-af2b-736da7eff252",
    "storage_key": "property/6767906449167301/019d02d5-d4c2-74da-af2b-736da7eff252.webp",
    "width": 300,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-6c74-753e-b680-26d731dae9a6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Santa Fe Suites logo",
    "public_id": "019d02d8-6c74-753e-b680-26d731dae9a6",
    "storage_key": "property/6767906449167301/019d02d8-6c74-753e-b680-26d731dae9a6.webp",
    "width": 300,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-723c-758b-8471-24c23181524d.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Santa Fe Suites logo",
    "public_id": "019d02d8-723c-758b-8471-24c23181524d",
    "storage_key": "property/6767906449167301/019d02d8-723c-758b-8471-24c23181524d.webp",
    "width": 300,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 1",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "287 sq ft",
  "property_sqft_min": "287",
  "property_sqft_max": "287",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/people/Santa-Fe-Suites/100087247180470/",
  "property_instagram_url": "https://www.instagram.com/santafesuitesnm/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9UGKhr1QGIcRk5XVgiEWd9k",
  "property_youtube_url": "https://www.youtube.com/watch?v=83suNcpbx5w&t=74",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment+Complex&find_loc=Santa+Fe%2C+NM",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Santa Fe Suites",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "At Santa Fe Suites, your ideal home awaits in vibrant Santa Fe, NM! Choose from stylish studios or spacious one-bedroom apartments, each boasting modern amenities like stainless steel appliances and high-speed Wi-Fi. Enjoy lush landscaping, a newly renovated picnic area, and easy access to Plaza Entrada shopping—all just steps from your door!",
  "property_home_floorplans_blurb": "Welcome to Santa Fe Suites, where the charm of Santa Fe, NM, meets comfortable living. Choose from our thoughtfully designed studio and one-bedroom floor plans, perfect for every lifestyle. Each home is a canvas for your creativity—browse our available apartment homes today and find your ideal retreat in this vibrant community.",
  "property_home_gallery_blurb": "At Santa Fe Suites, vibrant living awaits in our thoughtfully designed studio and one-bedroom apartments. Enjoy modern amenities like high-speed Wi-Fi, a renovated laundry facility, and a welcoming clubhouse. With scenic parks, shopping, and dining just steps away, picture yourself thriving in this pet-friendly, gated community!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Santa Fe, NM, Santa Fe Suites offers an array of stylish studio and one-bedroom floor plans, perfect for your unique lifestyle. Revel in nearby attractions like the Georgia O'Keeffe Museum, Santa Fe Railyard Park, and the celebrated Lensic Performing Arts Center. Embrace the culture right outside your door!",
  "property_home_reviews_blurb": "At Santa Fe Suites, our residents thrive in a friendly environment. “Very cute, very clean,” and always greeted with kindness, our community stands out with stunning views and complimentary breakfast. Join us in Santa Fe, NM, and see what our residents have to say about living at our welcoming community!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Santa Fe, Santa Fe Suites offers not just stylish studio and one-bedroom apartments, but also a gateway to culture and adventure. With nearby gems like the Georgia O'Keeffe Museum, Santa Fe Railyard Park, and the Santa Fe Opera, you’ll find inspiration at every turn. Explore the rich tapestry of our neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Santa Fe Suites, your new home awaits with inviting studio and one-bedroom floor plans. Enjoy amenities that enhance your lifestyle— from our newly renovated laundry facilities to beautifully landscaped common areas. Embrace convenience with community Wi-Fi, modern appliances, and nearby shopping, all while loving life with your pets by your side!",
  "property_applynow_blurb": "At Santa Fe Suites, find a welcoming community nestled near Santa Fe Community College and just minutes from shopping. Choose from studio or one-bedroom layouts, enjoy expansive outdoor spaces, and delight in new renovations. Experience hassle-free living with on-site management, high-speed Wi-Fi, and pet-friendly amenities. Lease your new home online today!",
  "property_contactus_blurb": "At Santa Fe Suites, find your perfect home with a variety of thoughtfully designed floor plans, including cozy studios and spacious one-bedroom options. Nestled in the heart of Santa Fe, NM, we're here to help you every step of the way. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Santa Fe Suites, your perfect home awaits, whether you prefer the cozy ambiance of a studio or the spacious charm of a one-bedroom apartment. Nestled in the heart of Santa Fe, NM, our community answers all your queries. Visit our FAQs page for insights into your future living experience!",
  "property_floorplans_blurb": "At Santa Fe Suites in picturesque Santa Fe, NM, each apartment home is designed with your lifestyle in mind. Choose from contemporary studios and spacious one-bedroom layouts that harmonize comfort and style. Browse our available floor plans today and step into your dream space amidst the charming essence of Santa Fe.",
  "property_gallery_blurb": "At Santa Fe Suites, vibrant living meets modern convenience. Choose from spacious studios or one-bedroom apartments, all enhanced by beautiful landscaping and community amenities. Picture yourself relaxing in the picnic area, enjoying high-speed Wi-Fi, or appealing clubhouse events. Discover your perfect home just moments from shopping and parks!",
  "property_interactivemap_blurb": "At Santa Fe Suites in vibrant Santa Fe, NM, your ideal living space awaits! Choose from stylish studio or one-bedroom floor plans, complete with modern amenities like a renovated laundry facility and expansive outdoor seating. Embrace a lifestyle of convenience and comfort—unleash your next adventure with our interactive community map!",
  "property_pets_blurb": "At Santa Fe Suites, your furry friends are cherished as part of the family! Nestled in vibrant Santa Fe, NM, our pet-enthusiastic community invites you and your dogs or cats to enjoy spacious living without heavy restrictions. Experience a welcoming home where tails wag and hearts thrive!",
  "property_referafriend_blurb": "At Santa Fe Suites, your dream home awaits with our stylish studio and spacious one-bedroom floor plans. Nestled in vibrant Santa Fe, NM, our welcoming community thrives on connections. Share the joy of living here—refer a friend today and create lasting memories with great neighbors!",
  "property_residentaccess_blurb": "Welcome to Santa Fe Suites, where comfort meets convenience in the heart of Santa Fe, NM. Whether you choose a cozy studio or a spacious one-bedroom layout, our thoughtfully designed apartments cater to your lifestyle. Access your resident portal today to manage payments, schedule maintenance, and embrace hassle-free living!",
  "property_reviews_blurb": "At Santa Fe Suites, our residents appreciate the attentive care of our team, with one saying, “Thank you Kayley for doing your best...you have helped me more than the past managers.” Enjoy clean, charming spaces, stunning views, and complimentary breakfast. See what our residents have to say about living at our community!",
  "property_created_at": "1772836773661",
  "property_scheduletour_blurb": "Nestled in the heart of Santa Fe, NM, Santa Fe Suites offers thoughtfully designed studio and one-bedroom apartments tailored for comfort and style. Experience vibrant living among stunning landscapes—schedule a tour today and hear firsthand why our residents love calling our community home!",
  "property_thankyou_blurb": "Thank you for reaching out to Santa Fe Suites! Our diverse floor plans, from cozy studios to spacious one-bedroom homes, are designed for your unique lifestyle. Expect a team member to contact you soon, helping you step closer to the vibrant living experience that Santa Fe, NM has to offer!",
  "property_virtualtours_blurb": "Experience the enchanting warmth of Santa Fe Suites, where charm meets modern living. Choose from stylish studio or spacious one-bedroom floor plans, all designed for your comfort. Step inside through our virtual tour and envision your next home in the heart of Santa Fe, NM. Your ideal oasis awaits!",
  "property_copyright": "2026 All Rights Reserved. Santa Fe Suites",
  "property_seo_title_home": "Santa Fe Suites |  Apartments in Santa Fe, NM",
  "property_seo_description_home": "Discover Santa Fe Suites: modern living, community charm, stylish plans, great amenities, and easy access to shopping and parks. Your home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Santa Fe, NM Apartments for Rent",
  "property_seo_description_floorplans": "Uncover your ideal living space at Santa Fe Suites in beautiful Santa Fe, NM. Choose from stylish studios and one-bedroom apartments. Find your fit today!",
  "property_seo_title_amenities": "Amenities | Santa Fe, NM Apartments for Rent",
  "property_seo_description_amenities": "Discover urban living at Santa Fe Suites! Enjoy modern amenities, beautiful floor plans, and pet-friendly spaces near shopping and parks. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Santa Fe, NM",
  "property_seo_description_gallery": "Experience modern comfort at Santa Fe Suites with lush landscapes, upgraded amenities, and a friendly community near shopping!",
  "property_seo_title_virtualtours": "Virtual Tours | Santa Fe Suites Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Santa Fe at Santa Fe Suites! Take a virtual tour of our inviting studio and one-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Santa Fe Suites Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Santa Fe Suites! With modern amenities, pet-friendly living, and a prime location near shopping and parks, your perfect space awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Santa Fe, NM",
  "property_seo_description_neighborhood": "Experience the charm of Santa Fe from Santa Fe Suites! Uncover local favorites and nearby attractions that enrich our vibrant community life.",
  "property_seo_title_contact": "Contact Us | Santa Fe Suites",
  "property_seo_description_contact": "Reach out to Santa Fe Suites in Santa Fe, NM! Choose from stylish studio or one-bedroom apartments. Have questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Santa Fe, NM",
  "property_seo_description_faqs": "Find answers to your questions at Santa Fe Suites! Explore our pet-friendly community, amenities, and nearby attractions in scenic Santa Fe, NM.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Santa Fe, NM",
  "property_seo_description_reviews": "Explore our Santa Fe Suites community! Read resident reviews to discover why our studio and one-bedroom apartments are perfect for you.",
  "property_seo_title_applynow": "Apply Now | Apartments in Santa Fe, NM",
  "property_seo_description_applynow": "Embrace life at Santa Fe Suites! Enjoy modern amenities, pet-friendly spaces, and proximity to Santa Fe Community College. Your ideal apartment awaits!",
  "property_seo_title_residentaccess": "Resident Access | Santa Fe Suites",
  "property_seo_description_residentaccess": "Access Santa Fe Suites' resident portal for rent payments, maintenance requests, and community updates—all at your fingertips in beautiful Santa Fe, NM!",
  "property_seo_title_referafriend": "Refer A Friend | Santa Fe Suites",
  "property_seo_description_referafriend": "Bring your friends to Santa Fe Suites! Refer a buddy and enjoy vibrant living in the heart of Santa Fe, NM. Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Santa Fe Suites",
  "property_seo_description_scheduletour": "Experience the charm of Santa Fe Suites! Immerse yourself in our vibrant community and stunning views—schedule your tour today for an unforgettable experience!",
  "property_seo_title_privacy": "Privacy Policy | Santa Fe Suites",
  "property_seo_description_privacy": "Rest easy at Santa Fe Suites! Your privacy matters to us. Dive into our privacy policy for a transparent look at how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Santa Fe Suites",
  "property_seo_description_accessibility": "Enhance your experience at Santa Fe Suites with our commitment to digital accessibility. We believe everyone deserves easy access to information and community.",
  "property_seo_title_sitemap": "Sitemap | Santa Fe Suites",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Santa Fe Suites. Check our sitemap for a seamless journey through exceptional living in Santa Fe, NM!",
  "property_seo_title_thankyou": "Thank You | Santa Fe Suites",
  "property_seo_description_thankyou": "Thanks for reaching out to Santa Fe Suites! Our team will connect with you soon about your new home in the heart of beautiful Santa Fe, NM.",
  "property_seo_title_pets": "Pet Policy | Apartments in Santa Fe, NM",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786634907431",
  "amenities": [],
  "photo_gallery": [
    {
      "id": "custom_966d8356-867e-428d-8d6e-1675f0525088",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-3780-75ad-8026-14363d1ed8b0.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red roofs and orange walls, courtyards with gravel and walkways.",
        "public_id": "019d02d8-3780-75ad-8026-14363d1ed8b0",
        "storage_key": "property/6767906449167301/019d02d8-3780-75ad-8026-14363d1ed8b0.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring red roofs and warm orange walls. The property includes well-maintained courtyards with gravel paths and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with red roofs and orange walls, courtyards with gravel and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21f6fb15-2a0e-44b7-ab7f-fa5fe66a10b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-37de-73dc-b2a6-bda089fb641f.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with red bushes and gravel landscaping.",
        "public_id": "019d02d8-37de-73dc-b2a6-bda089fb641f",
        "storage_key": "property/6767906449167301/019d02d8-37de-73dc-b2a6-bda089fb641f.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a welcoming entrance, lush red bushes, and well-maintained gravel landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with red bushes and gravel landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8392e0e-7336-4458-9802-8df76e817a3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-3172-77eb-a4a3-5be74d884bc3.webp",
      "image_media": {
        "alt_text": "Welcome entrance with pergola and potted plants.",
        "public_id": "019d02d8-3172-77eb-a4a3-5be74d884bc3",
        "storage_key": "property/6767906449167301/019d02d8-3172-77eb-a4a3-5be74d884bc3.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming welcome entrance featuring a pergola, vibrant potted plants, and a \"Welcome\" sign above the door.",
      "link": "",
      "alt_text": "Welcome entrance with pergola and potted plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6655e8b1-22c4-4ea6-a274-ecb8f2366624",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-2ec3-768b-b790-2fe5fee20eb5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartments with a walkway and neatly trimmed bushes.",
        "public_id": "019d02d8-2ec3-768b-b790-2fe5fee20eb5",
        "storage_key": "property/6767906449167301/019d02d8-2ec3-768b-b790-2fe5fee20eb5.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming apartment building exteriors featuring clean walkways, well-maintained landscaping, and inviting entrances. Enjoy the beautiful outdoor spaces.",
      "link": "",
      "alt_text": "Exterior view of apartments with a walkway and neatly trimmed bushes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0e79366-ccd4-498e-a8a2-9c8ced027794",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-2d35-75ea-9f29-1c77769d5187.webp",
      "image_media": {
        "alt_text": "View of apartment building exteriors with a pathway between them.",
        "public_id": "019d02d8-2d35-75ea-9f29-1c77769d5187",
        "storage_key": "property/6767906449167301/019d02d8-2d35-75ea-9f29-1c77769d5187.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing a walkway between units.",
      "link": "",
      "alt_text": "View of apartment building exteriors with a pathway between them.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54728227-a1f6-46a6-b873-246fab9b7db5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-10df-725b-bdca-eedf618408cb.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with orange roofs and stucco walls.",
        "public_id": "019d02d8-10df-725b-bdca-eedf618408cb",
        "storage_key": "property/6767906449167301/019d02d8-10df-725b-bdca-eedf618408cb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring bright orange roofs and stucco exteriors, set within a well-maintained community courtyard.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with orange roofs and stucco walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b03d76ec-904c-42f5-9fad-f88dd2066764",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d8-0b54-7557-afe8-8ea8cf8648b5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and a picnic table.",
        "public_id": "019d02d8-0b54-7557-afe8-8ea8cf8648b5",
        "storage_key": "property/6767906449167301/019d02d8-0b54-7557-afe8-8ea8cf8648b5.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Community",
      "description": "Charming apartment buildings with red roofs and stucco exteriors, surrounded by lush landscaping, walkways, and a picnic area.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and a picnic table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_398dfd13-1e70-4200-8d75-f66386322f45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-fdb8-752e-b0d8-d7e976ecbd3d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with red roofs and autumn foliage, showing parking lots and landscaping.",
        "public_id": "019d02d7-fdb8-752e-b0d8-d7e976ecbd3d",
        "storage_key": "property/6767906449167301/019d02d7-fdb8-752e-b0d8-d7e976ecbd3d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Experience comfortable living in our community, surrounded by beautiful autumn colors. Explore the exterior views and amenities of our apartment complex.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with red roofs and autumn foliage, showing parking lots and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5926e5c7-212d-4faa-ab45-e1ecde4a97ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-fdbb-73c9-975d-1facf61ffecf.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with red roofs and surrounding parking lots and landscaping.",
        "public_id": "019d02d7-fdbb-73c9-975d-1facf61ffecf",
        "storage_key": "property/6767906449167301/019d02d7-fdbb-73c9-975d-1facf61ffecf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Experience comfortable living in this apartment community, featuring well-maintained buildings, ample parking, and lush surroundings. Located near shopping and amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with red roofs and surrounding parking lots and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfcfb55e-3d39-479f-a1c7-5ecb0b0ec839",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming apartment building with stucco exterior and inviting courtyards, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_303878d5-9ba8-4994-b25c-d55757a2ca9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-28ed-762c-8083-855b5249d48e.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with green picnic tables and benches.",
        "public_id": "019d02d6-28ed-762c-8083-855b5249d48e",
        "storage_key": "property/6767906449167301/019d02d6-28ed-762c-8083-855b5249d48e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the fresh air and dine al fresco in our outdoor picnic area, featuring comfortable seating and shaded tables.",
      "link": "",
      "alt_text": "Outdoor picnic area with green picnic tables and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_221a33b7-1924-4de6-8c9b-25d057a0bd05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-25cb-74a9-a3f1-c6e101206eac.webp",
      "image_media": {
        "alt_text": "Picnic tables in an outdoor common area with trees and parking lot.",
        "public_id": "019d02d6-25cb-74a9-a3f1-c6e101206eac",
        "storage_key": "property/6767906449167301/019d02d6-25cb-74a9-a3f1-c6e101206eac.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in the community picnic area, perfect for a breath of fresh air.",
      "link": "",
      "alt_text": "Picnic tables in an outdoor common area with trees and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_224952d4-f6a9-4ed4-ae43-3e6d6b5cd8c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-f24b-7679-83b6-a3009938b368.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets.",
        "public_id": "019d02d5-f24b-7679-83b6-a3009938b368",
        "storage_key": "property/6767906449167301/019d02d5-f24b-7679-83b6-a3009938b368.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into this updated kitchen featuring sleek black appliances, ample cabinet space, and durable countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8bbc763b-146e-4941-9f65-b2abb2c6e6bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-ed83-717b-abf0-0835a3872ea9.webp",
      "image_media": {
        "alt_text": "Black refrigerator and stove in a compact kitchen with white cabinets and a stainless steel microwave.",
        "public_id": "019d02d5-ed83-717b-abf0-0835a3872ea9",
        "storage_key": "property/6767906449167301/019d02d5-ed83-717b-abf0-0835a3872ea9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A compact kitchen featuring a black refrigerator, black stove, and stainless steel microwave, complemented by white cabinetry.",
      "link": "",
      "alt_text": "Black refrigerator and stove in a compact kitchen with white cabinets and a stainless steel microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3f72b0f-5ff4-419e-802e-f7c091f9a074",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-ea8c-7032-bfdc-76c84645fcf3.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a marble countertop.",
        "public_id": "019d02d5-ea8c-7032-bfdc-76c84645fcf3",
        "storage_key": "property/6767906449167301/019d02d5-ea8c-7032-bfdc-76c84645fcf3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring sleek white cabinetry, a stainless steel microwave, a black stove and refrigerator, and a granite countertop with a convenient breakfast bar.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, black appliances, and a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df4ac6c7-66b2-4ab3-9234-d91d3aee6992",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-dec2-71f9-807d-cb7b640ac7b3.webp",
      "image_media": {
        "alt_text": "View of a studio apartment living room with a small kitchen area to the right.",
        "public_id": "019d02d5-dec2-71f9-807d-cb7b640ac7b3",
        "storage_key": "property/6767906449167301/019d02d5-dec2-71f9-807d-cb7b640ac7b3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy studio apartment featuring a living area with plush carpeting and an adjacent kitchen with white cabinetry and a breakfast bar.",
      "link": "",
      "alt_text": "View of a studio apartment living room with a small kitchen area to the right.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ec316c8-4e7b-4f8e-9f0e-ee98550eab77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d5-de24-721b-ad45-3f1ffc6612ed.webp",
      "image_media": {
        "alt_text": "Kitchen and living area",
        "public_id": "019d02d5-de24-721b-ad45-3f1ffc6612ed",
        "storage_key": "property/6767906449167301/019d02d5-de24-721b-ad45-3f1ffc6612ed.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living area and kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen and living area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fe8bf06c-9706-43ea-acf2-bef04d88fe0d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Tomasita's Santa Fe New Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "500 S Guadalupe St, Santa Fe, NM 87501, USA",
      "poi_short_description": "Lively go-to for enchiladas, sopapillas, flautas & more Southwestern favorites amid basic decor.",
      "poi_long_description": "People say this restaurant serves delicious New Mexican food, including blue corn enchiladas, carne adovada, and chile relleno. They highlight the generous portions, reasonable prices, and the complimentary sopapillas with honey butter. They also like the lively atmosphere and the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-474c-7525-8d88-41f125c9f307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-474c-7525-8d88-41f125c9f307",
        "storage_key": "property/6767906449167301/019d02d7-474c-7525-8d88-41f125c9f307.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tomasitas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14586014722387557001&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tomasitas-santa-fe-new-mexican-restaurant",
      "poi_latitude": "35.6839606",
      "poi_longitude": "-105.9463121",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 505-983-5721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-bd8bc7b2cef7",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw64N_UFQGIcRiTqHKBzva8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "southwestern_us_restaurant"
    },
    {
      "id": "custom_2f1087e3-c723-4f0e-a166-a1fb2fce5cd8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "The Shed",
      "poi_type": "Restaurants",
      "poi_address": "113 1/2 E Palace Ave, Santa Fe, NM 87501, USA",
      "poi_short_description": "Local go-to for classic Southwestern fare housed in a circa-1692 hacienda with a cantina-style bar.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chile stew, blue corn tacos, and Shed corn chowder. They also highlight the vibrant atmosphere, friendly staff, and reasonable portions.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-9869-70cb-8b1d-9f6e868ca933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-9869-70cb-8b1d-9f6e868ca933",
        "storage_key": "property/6767906449167301/019d02d6-9869-70cb-8b1d-9f6e868ca933.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sfshed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7287260169028535228&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shed",
      "poi_latitude": "35.6874931",
      "poi_longitude": "-105.9370271",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-982-9030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-bd8bc7b2cef7",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6M1OU1QGIcRvIPMoIOMIWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_06f6eb34-f4c0-4e17-a602-e3b5f6321891",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Cafe Pasqual's",
      "poi_type": "Restaurants",
      "poi_address": "121 Don Gaspar Ave, Santa Fe, NM 87501, USA",
      "poi_short_description": "Mexican fare from local & organic ingredients along with a community table in a historic adobe.",
      "poi_long_description": "People say this restaurant serves delicious mole sauce, a perfect Plato Supremo, and fresh green goddess salad. They highlight the fun, colorful atmosphere, and the friendly staff. They also like the option of a communal table for a social dining experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-95a8-7678-9946-fd4255cc229e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-95a8-7678-9946-fd4255cc229e",
        "storage_key": "property/6767906449167301/019d02d6-95a8-7678-9946-fd4255cc229e.webp",
        "width": 1280,
        "height": 987
      },
      "poi_business_url": "http://www.pasquals.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7025910105218768594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cafe-pasquals",
      "poi_latitude": "35.6866052",
      "poi_longitude": "-105.9396614",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-983-9340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-bd8bc7b2cef7",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP36d2UZQGIcR0l5kDQQMgWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "southwestern_us_restaurant"
    },
    {
      "id": "custom_0df05655-a1b2-4b60-82d5-758d9a13f902",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "La Choza Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "905 Alarid St, Santa Fe, NM 87505, USA",
      "poi_short_description": "Casual eatery with colorful decor features tacos, burritos & more with a separate vegetarian menu.",
      "poi_long_description": "People say this Mexican restaurant serves delicious enchiladas, salsa, and queso. They highlight the authentic New Mexican cuisine and the pleasant atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-4747-70c8-afd9-5f7fc708b382.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-4747-70c8-afd9-5f7fc708b382",
        "storage_key": "property/6767906449167301/019d02d7-4747-70c8-afd9-5f7fc708b382.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lachozasf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1473644710992868931&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-choza-restaurant",
      "poi_latitude": "35.6791618",
      "poi_longitude": "-105.9527641",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 505-982-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-bd8bc7b2cef7",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8i3L29QGIcRQ_bckw5wcxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_708c1696-72e1-48e6-8a59-ad9e8652f1ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Coyote Cafe & Rooftop Cantina",
      "poi_type": "Restaurants",
      "poi_address": "132 W Water St, Santa Fe, NM 87501, USA",
      "poi_short_description": "Elegant eatery featuring local cuisine with Southwestern flair, cocktails & a rooftop bar.",
      "poi_long_description": "People say this restaurant offers delicious and creative Southwestern cuisine, including elk tenderloin, corn cakes with shrimp, and a variety of tacos. They also highlight the fun and lively atmosphere, especially on the rooftop, and the attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-986d-75a9-b9bc-6bdfa419fb1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-986d-75a9-b9bc-6bdfa419fb1c",
        "storage_key": "property/6767906449167301/019d02d6-986d-75a9-b9bc-6bdfa419fb1c.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://www.coyotecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3199342848060455469&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coyote-cafe--rooftop-cantina",
      "poi_latitude": "35.6865791",
      "poi_longitude": "-105.9405899",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 505-983-1615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-bd8bc7b2cef7",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-bd8bc7b2cef7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8mU1kZQGIcRLXpUlV5ZZiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "southwestern_us_restaurant"
    },
    {
      "id": "custom_b55a8dba-d935-4a84-be49-07148db1ccad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "753 Cerrillos Rd, Santa Fe, NM 87505, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic options, and prepared foods. They also highlight the friendly and helpful staff, and the fun, adventurous vibe.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-a84a-724b-bfd6-091bf704a82c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a84a-724b-bfd6-091bf704a82c",
        "storage_key": "property/6767906449167301/019d02d6-a84a-724b-bfd6-091bf704a82c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/cerrillos?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12702831948788780553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.679077",
      "poi_longitude": "-105.9500674",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 505-992-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-c201e7c3fd32",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaIM7mhQGIcRCc4J3VqGSbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ae513400-4a95-4f07-8148-bdb507056114",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "530 W Cordova Rd, Santa Fe, NM 87505, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers unique items, a wide selection of wine, and healthy choices. They highlight the competitive prices, especially on cheese, nuts, eggs, dairy, frozen items, and canned goods, and the fun shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-a6f0-7009-8cf8-420851b70b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-a6f0-7009-8cf8-420851b70b4d",
        "storage_key": "property/6767906449167301/019d02d6-a6f0-7009-8cf8-420851b70b4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/nm/santa-fe/165/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12087364927556731305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.6729716",
      "poi_longitude": "-105.953372",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 505-995-8145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-c201e7c3fd32",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58MNnWZQGIcRqcGIKVzyvqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a44ae1eb-3f66-4495-9b18-00329b493439",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "199 Paseo De Peralta, Santa Fe, NM 87501, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh and organic produce, interesting cheeses, and bulk items like grains, nuts, and seeds. They also highlight the friendly and helpful staff, reasonable prices, and good deals.\n\nSome reviews mention the produce can be better elsewhere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-4a7e-767d-9568-56745cdda7b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-4a7e-767d-9568-56745cdda7b7",
        "storage_key": "property/6767906449167301/019d02d7-4a7e-767d-9568-56745cdda7b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/nm/santa-fe/santa-fe-paseo-de-peralta",
      "poi_directions_map_url": "https://maps.google.com/?cid=4765667458429943363&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.6926346",
      "poi_longitude": "-105.949706",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-988-1140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-c201e7c3fd32",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdR-MxRQGIcRQ_5ayU0NI0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ac705b3f-4694-4273-b895-d92e7cfe98af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Place Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4250 Cerrillos Rd, Santa Fe, NM 87507, USA",
      "poi_short_description": "Shopping mall featuring clothing stores, a food court, a cinema & a small carousel for kids.",
      "poi_long_description": "People say this shopping center offers a diverse selection of stores and dining options. They also highlight the spacious layout, clean restrooms, and fun activities for kids.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-ad2c-7093-8cca-718ca9ae845c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-ad2c-7093-8cca-718ca9ae845c",
        "storage_key": "property/6767906449167301/019d02d6-ad2c-7093-8cca-718ca9ae845c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://santafeplacemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1258605272679124016&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-place-mall",
      "poi_latitude": "35.6360956",
      "poi_longitude": "-106.0146848",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-473-4253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0eaa-75ff-96f5-867f7b271e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0eaa-75ff-96f5-867f7b271e7c",
        "storage_key": "property/6767906449167301/019d02d7-0eaa-75ff-96f5-867f7b271e7c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp22WfDVaGIcRMAx5vtN2dxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6d50b5bf-d887-4462-bcee-744484f9b66d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Market Street",
      "poi_type": "Shopping & Retail",
      "poi_address": "600 N Guadalupe St, Santa Fe, NM 87501, USA",
      "poi_short_description": "Chain grocery outlet offering a wide selection of products, including organic foods, and a pharmacy.",
      "poi_long_description": "People say this grocery store is clean, well-stocked, and offers a wide selection of products at affordable prices, including options for different dietary restrictions. They also highlight the friendly and helpful staff, and the respectful management.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-4dcd-7089-9bc3-5b0f3b3f7ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-4dcd-7089-9bc3-5b0f3b3f7ce4",
        "storage_key": "property/6767906449167301/019d02d7-4dcd-7089-9bc3-5b0f3b3f7ce4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.marketstreetunited.com/nm/santa-fe/600-n-guadalupe-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3450293177967375201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "35.69387469999999",
      "poi_longitude": "-105.9513974",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-982-4668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d2-729c-8256-c201e7c3fd32",
        "storage_key": "property/6767906449167301/019d02d7-09d2-729c-8256-c201e7c3fd32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-DXohZQGIcRYfOya13n4S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_63296abf-a7c9-47b3-95ad-d9b18009bf1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Community College",
      "poi_type": "Education",
      "poi_address": "6401 Richards Ave, Santa Fe, NM 87508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-b9a3-706d-a660-4dba9eaabf2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b9a3-706d-a660-4dba9eaabf2c",
        "storage_key": "property/6767906449167301/019d02d6-b9a3-706d-a660-4dba9eaabf2c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sfcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16577843384497594007&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-community-college",
      "poi_latitude": "35.6050125",
      "poi_longitude": "-105.9982209",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-428-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd5QjppNZGIcRl94Jm7lUEOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_776255d5-b8d1-4068-b7ce-33da82609dd6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "St. John's College",
      "poi_type": "Education",
      "poi_address": "1160 Camino De Cruz Blanca, Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-b720-74fb-bfab-67124d401458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-b720-74fb-bfab-67124d401458",
        "storage_key": "property/6767906449167301/019d02d6-b720-74fb-bfab-67124d401458.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.sjc.edu/?utm_source=google&utm_medium=gmb&utm_campaign=santa-fe",
      "poi_directions_map_url": "https://maps.google.com/?cid=13540357969463291405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-johns-college",
      "poi_latitude": "35.666789",
      "poi_longitude": "-105.912226",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-984-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjfjEFQZRGIcRDS59VdUD6bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c11bb3cf-b62d-4677-b20b-7b1da730c838",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Public Library - La Farge Branch",
      "poi_type": "Education",
      "poi_address": "1730 Llano St, Santa Fe, NM 87505, USA",
      "poi_short_description": "Mid-town branch of the Santa Fe Public Library system with a kids' room, books, computers, and Wi-Fi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-50c0-706e-bbfb-0890853cc963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-50c0-706e-bbfb-0890853cc963",
        "storage_key": "property/6767906449167301/019d02d7-50c0-706e-bbfb-0890853cc963.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://santafelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1040561643907779560&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-public-library---la-farge-branch",
      "poi_latitude": "35.65432029999999",
      "poi_longitude": "-105.9719653",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 505-955-4860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqzfBXnhaGIcR6AsFUE3RcA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2ba971ef-88e3-4617-9400-4b1a480780a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Plaza",
      "poi_type": "Entertainment",
      "poi_address": "63 Lincoln Ave, Santa Fe, NM 87501, USA",
      "poi_short_description": "Historic city plaza with benches, a bandstand & ethnic markets, plus festivals & community events.",
      "poi_long_description": "People say this historical landmark offers a variety of shops, restaurants, and galleries, as well as live music and cultural events. They highlight the beautiful scenery, rich history, and vibrant atmosphere, and like the opportunity to purchase Native jewelry and art. They also mention the friendly people and the fun, lively vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5404-763f-8121-ab9d87f6f466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5404-763f-8121-ab9d87f6f466",
        "storage_key": "property/6767906449167301/019d02d7-5404-763f-8121-ab9d87f6f466.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.santafenm.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=410234213081149643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-plaza",
      "poi_latitude": "35.6874369",
      "poi_longitude": "-105.9385238",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-955-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc4140ZQGIcRy_Bp4ddxsQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_e1e451b7-137a-4504-84e2-3d000666865c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Georgia O'Keeffe Museum",
      "poi_type": "Entertainment",
      "poi_address": "217 Johnson St, Santa Fe, NM 87501, USA",
      "poi_short_description": "Rotating exhibits of the work of Georgia O'Keeffe include paintings, sculptures & sketches.",
      "poi_long_description": "People say this museum offers an amazing collection of art and personal belongings that provide a comprehensive look into the artist's life and work. They highlight the informative and immersive experience, and the free audio tour that enhances the visit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-c0d8-71f8-b107-4671ca706981.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-c0d8-71f8-b107-4671ca706981",
        "storage_key": "property/6767906449167301/019d02d6-c0d8-71f8-b107-4671ca706981.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://okeeffemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315933292621040249&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-okeeffe-museum",
      "poi_latitude": "35.6891517",
      "poi_longitude": "-105.9412918",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-946-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0f29-773f-8ad6-9f7ef3cb7666",
        "storage_key": "property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3VOprUBQGIcReYrpwfjXSIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3bc8852a-232b-4474-b09d-b7947e82b71d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Loretto Chapel Museum",
      "poi_type": "Entertainment",
      "poi_address": "207 Old Santa Fe Trail, Santa Fe, NM 87501, USA",
      "poi_short_description": "Historic site for weddings & events with a notable spiral staircase with a legend behind it.",
      "poi_long_description": "People say this museum features a beautiful chapel and a unique spiral staircase with an interesting history. They highlight the peaceful and spiritual atmosphere, and the reasonable entrance fee. They also like the informative audio narration and the large gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-56ff-7648-9261-f6c0315b4f67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-56ff-7648-9261-f6c0315b4f67",
        "storage_key": "property/6767906449167301/019d02d7-56ff-7648-9261-f6c0315b4f67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lorettochapel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3077231034655605277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loretto-chapel-museum",
      "poi_latitude": "35.6856277",
      "poi_longitude": "-105.9374917",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-982-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0f29-773f-8ad6-9f7ef3cb7666",
        "storage_key": "property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ZJirS1RGIcRHYJ0eFKFtCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c0ead217-f979-4321-aa5d-1a00741b8a5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Museum of International Folk Art",
      "poi_type": "Entertainment",
      "poi_address": "On Museum Hill, 706 Camino Lejo, Santa Fe, NM 87505, USA",
      "poi_short_description": "80,000-sq-ft homage to global folk art & culture, featuring art & artifacts from over 100 countries.",
      "poi_long_description": "People say this museum showcases a vast collection of folk art from around the world, including ceramics, miniatures, and toys. They highlight the unique and fascinating exhibits, such as the telephone wire and prison art shows, and the well-organized and displayed collection. They also like the helpful wall labels, storytelling videos, and the gift shop with artist crafts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-57ac-759d-a403-4f49ed2dfbe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-57ac-759d-a403-4f49ed2dfbe2",
        "storage_key": "property/6767906449167301/019d02d7-57ac-759d-a403-4f49ed2dfbe2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.moifa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9487731362818051058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-international-folk-art",
      "poi_latitude": "35.6640586",
      "poi_longitude": "-105.9265002",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 505-476-1204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0f29-773f-8ad6-9f7ef3cb7666",
        "storage_key": "property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69AfLvxQGIcR8ksaBWgxq4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7903039b-311b-4910-81df-144e6cfaa290",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Palace of the Governors at New Mexico History Museum",
      "poi_type": "Entertainment",
      "poi_address": "105 W Palace Ave, Santa Fe, NM 87501, USA",
      "poi_short_description": "Santa Fe history museum also provides informational exhibits on the development of New Mexico.",
      "poi_long_description": "Santa Fe history museum also provides informational exhibits on the development of New Mexico.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5b18-726d-8db7-65ce094b09fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5b18-726d-8db7-65ce094b09fa",
        "storage_key": "property/6767906449167301/019d02d7-5b18-726d-8db7-65ce094b09fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nmhistorymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4487154007435568703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palace-of-the-governors-at-new-mexico-history-museum",
      "poi_latitude": "35.68782849999999",
      "poi_longitude": "-105.938226",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-476-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0f29-773f-8ad6-9f7ef3cb7666",
        "storage_key": "property/6767906449167301/019d02d7-0f29-773f-8ad6-9f7ef3cb7666.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRulD0dQGIcRP-aqucuSRT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_48ceb695-fda2-4e48-af81-93a3dd1ee599",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2412 Cerrillos Rd, Santa Fe, NM 87505, USA",
      "poi_short_description": "Chain gym featuring standard workout machines, plus massage areas and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and exercise options, and has a clean and well-maintained environment. They also highlight the friendly and helpful staff, and the comfortable and welcoming atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-d8e0-7311-a8da-72c04b59ac25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-d8e0-7311-a8da-72c04b59ac25",
        "storage_key": "property/6767906449167301/019d02d6-d8e0-7311-a8da-72c04b59ac25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/santa-fe-cerrillos-nm?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896463192524304630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6590461",
      "poi_longitude": "-105.9807789",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 505-522-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8eR1GJaGIcR9rAvvlS780M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_460bc8c3-bce5-404d-af2a-4ccbcb4f859f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Mosaic Animal Emergency and Specialty Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2001 Vivigen Way, Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5bf4-75ac-9feb-4ce77d1748f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5bf4-75ac-9feb-4ce77d1748f1",
        "storage_key": "property/6767906449167301/019d02d7-5bf4-75ac-9feb-4ce77d1748f1.webp",
        "width": 1280,
        "height": 880
      },
      "poi_business_url": "http://mosaicanimal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15293567559273255011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mosaic-animal-emergency-and-specialty-hospital",
      "poi_latitude": "35.638034",
      "poi_longitude": "-105.960464",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 505-416-5840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyacIeABRGIcRY5DrlqqqPdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_bad92b45-f894-4433-b3f4-b11e40a7637f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Defined Fitness Capital Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3320 Cerrillos Rd, Santa Fe, NM 87507, USA",
      "poi_short_description": "Membership-only fitness center offering equipment, a pool, and massage services, plus classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including squat racks, benches, and free weights, and has a pool and classes.\n\nOther reviews mention the gym can be crowded and the management can be inflexible.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5c42-77f0-a152-19fe33f47b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5c42-77f0-a152-19fe33f47b16",
        "storage_key": "property/6767906449167301/019d02d7-5c42-77f0-a152-19fe33f47b16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://defined.com/club/capital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1402778802173493631&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "defined-fitness-capital-club",
      "poi_latitude": "35.6483567",
      "poi_longitude": "-106.0011118",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-438-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6GZ7ENbGIcRf8H_aeOrdxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ad7cdb45-44de-4170-9c7a-a46e65bf336e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "SANTA FE SPA",
      "poi_type": "Health and Wellness",
      "poi_address": "786 Calle Mejia, Santa Fe, NM 87501, USA",
      "poi_short_description": "Upbeat, clean workout facility offering cardio and weight-training machines, plus free weights and classes.",
      "poi_long_description": "People say this gym has a great selection of equipment, from cardio machines to strength training options, and they appreciate the spacious layout. They also highlight the friendly and accommodating staff, and the option to try out the gym for short periods before committing to a membership.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-da76-76b6-b9b4-d97fc2cd8307.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-da76-76b6-b9b4-d97fc2cd8307",
        "storage_key": "property/6767906449167301/019d02d6-da76-76b6-b9b4-d97fc2cd8307.webp",
        "width": 685,
        "height": 386
      },
      "poi_business_url": "https://www.santafespa.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17910071262103005868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-spa",
      "poi_latitude": "35.700192",
      "poi_longitude": "-105.9525134",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-984-8727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SerIBpQGIcRrOqU1-tajfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87233025-833d-4675-b971-4365f82975e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "The Center Barber & Beauty Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "503 W Cordova Rd, Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5de1-7758-a20e-d14d35aeea37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5de1-7758-a20e-d14d35aeea37",
        "storage_key": "property/6767906449167301/019d02d7-5de1-7758-a20e-d14d35aeea37.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://centerbarbershop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13456079479888514211&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-center-barber--beauty-shop",
      "poi_latitude": "35.6732544",
      "poi_longitude": "-105.9493146",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 505-982-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6gM1GZQGIcRo4wtXP6Yvbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_6c2cd1ba-2a36-41fe-bc0a-b65a2289e651",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Community Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3229 Richards Ln Unit B, Santa Fe, NM 87507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-5fc8-75fb-920a-d1dd1fb3da2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-5fc8-75fb-920a-d1dd1fb3da2f",
        "storage_key": "property/6767906449167301/019d02d7-5fc8-75fb-920a-d1dd1fb3da2f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.santafecommunityyoga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4573266855353249969&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-community-yoga",
      "poi_latitude": "35.65688",
      "poi_longitude": "-106.0011577",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-820-9363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLfjR_IdQGIcRsfBliPmBdz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_5948569b-fbf3-4b6d-9591-5b3fb9287289",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe THRIVE",
      "poi_type": "Health and Wellness",
      "poi_address": "947 W Alameda St, Santa Fe, NM 87501, USA",
      "poi_short_description": "Welcoming studio, featuring heated yoga, plus cycling and fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-60da-739c-89c6-b435e1051167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-60da-739c-89c6-b435e1051167",
        "storage_key": "property/6767906449167301/019d02d7-60da-739c-89c6-b435e1051167.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.santafethrive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13981215486413281173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-thrive",
      "poi_latitude": "35.6890221",
      "poi_longitude": "-105.959563",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 505-930-5923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjV_9cg1QGIcRlZfaw2hBB8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_614674c6-b7bf-46b4-9360-479277dd0da3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Evolution Hair Design",
      "poi_type": "Health and Wellness",
      "poi_address": "6640 Cerrillos Rd Unit B, Santa Fe, NM 87507, USA",
      "poi_short_description": "Coffee shop and hair salon offering a variety of cuts, beard trims and mask treatments, plus color services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-61a6-752f-8747-58bc99cb433a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-61a6-752f-8747-58bc99cb433a",
        "storage_key": "property/6767906449167301/019d02d7-61a6-752f-8747-58bc99cb433a.webp",
        "width": 969,
        "height": 1280
      },
      "poi_business_url": "http://www.evohairdesign.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18330879658970833317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "evolution-hair-design",
      "poi_latitude": "35.6241492",
      "poi_longitude": "-106.0257298",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-819-8055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyK6Sk9aGIcRpeFjve1dZP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_75b92a52-53cd-4821-a7d3-d3e8722d22bc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Serenity Nail Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "4056 Cerrillos Rd Suite E1, Santa Fe, NM 87507, USA",
      "poi_short_description": "Relaxed venue specializing in waxing, pedicures and manicures, plus gel nails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-629e-748e-811e-fcc99c8dd369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-629e-748e-811e-fcc99c8dd369",
        "storage_key": "property/6767906449167301/019d02d7-629e-748e-811e-fcc99c8dd369.webp",
        "width": 749,
        "height": 554
      },
      "poi_business_url": "http://serenitynailspasantafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5809503511707105031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "serenity-nail-spa",
      "poi_latitude": "35.6389691",
      "poi_longitude": "-106.0153641",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 505-471-2106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ01W3kpaGIcRB7ev8KmAn1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_9afd272f-e8ac-4782-9214-c5f012eb7290",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Dirty Laundry Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "2019 Galisteo St N-6, Santa Fe, NM 87505, USA",
      "poi_short_description": "Studio offering hot yoga classes in the Galisteo Center Office Park.",
      "poi_long_description": "People say this yoga studio offers a variety of class types, including hot yoga, sculpt, and power flow, and has amazing instructors. They highlight the welcoming, fun, and inclusive atmosphere, and the challenging and motivating classes. They also like the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-6482-7151-ad81-9b0db70ee23b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-6482-7151-ad81-9b0db70ee23b",
        "storage_key": "property/6767906449167301/019d02d7-6482-7151-ad81-9b0db70ee23b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dirtylaundryhotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8702487256799208322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dirty-laundry-hot-yoga",
      "poi_latitude": "35.6562496",
      "poi_longitude": "-105.9513387",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 505-395-6606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCYku-0BRGIcRgmPhYw1yxXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_1caf1221-77a0-4ee9-ad80-423353abcdea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Presbyterian Santa Fe Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Beckner Rd, Santa Fe, NM 87507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-f588-7488-b997-154e899e1828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-f588-7488-b997-154e899e1828",
        "storage_key": "property/6767906449167301/019d02d6-f588-7488-b997-154e899e1828.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.phs.org/santa-fe-medical-center?utm_source=gmb&utm_medium=organic&utm_campaign=listing&utm_content=_loc_sf_sfmc_hospital__l035",
      "poi_directions_map_url": "https://maps.google.com/?cid=13722759048740527142&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "presbyterian-santa-fe-medical-center",
      "poi_latitude": "35.6159061",
      "poi_longitude": "-106.0247216",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-772-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-13a6-740f-85ea-a92c0cfcea40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-13a6-740f-85ea-a92c0cfcea40",
        "storage_key": "property/6767906449167301/019d02d7-13a6-740f-85ea-a92c0cfcea40.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xUwa0lbGIcRJtx0BqYIcb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cc73cf8e-b657-4d22-9f01-16f2f560f1b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "CHRISTUS St. Vincent Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "455 St Michaels Dr, Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-ce6f-7632-8327-e48969df27e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-ce6f-7632-8327-e48969df27e7",
        "storage_key": "property/6767906449167301/019d02d6-ce6f-7632-8327-e48969df27e7.webp",
        "width": 1280,
        "height": 329
      },
      "poi_business_url": "https://www.christushealth.org/locations/st-vincent?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3687382236458172094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christus-st-vincent-regional-medical-center",
      "poi_latitude": "35.659319",
      "poi_longitude": "-105.945292",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 505-913-3361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-13a6-740f-85ea-a92c0cfcea40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-13a6-740f-85ea-a92c0cfcea40",
        "storage_key": "property/6767906449167301/019d02d7-13a6-740f-85ea-a92c0cfcea40.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoRTCufJQGIcRvr4sg5s2LDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cc06ce3b-9fe3-47a1-88c0-87da045e36a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "715 Camino Lejo, Santa Fe, NM 87505, USA",
      "poi_short_description": "Botanical center for tours & plant education set within a piñon-juniper woodland.",
      "poi_long_description": "People say this botanical garden offers a beautiful display of native plants, interesting sculptures, and scenic walking paths. They highlight the peaceful and relaxing vibe, and the educational experience provided by the knowledgeable staff and guided tours. They also like the convenient amenities, such as UV-protectant umbrellas and water refill stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-e7e0-755b-8ad4-2b5387483205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-e7e0-755b-8ad4-2b5387483205",
        "storage_key": "property/6767906449167301/019d02d6-e7e0-755b-8ad4-2b5387483205.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.visitsfbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9242424807881498233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-botanical-garden",
      "poi_latitude": "35.6656347",
      "poi_longitude": "-105.9270284",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 505-471-9103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4s7Xf5QGIcRed4I8WSwQ4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_e2dfdfea-2a7c-4d66-a77a-e17d140967bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Cross of the Martyrs",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "617 Paseo De Peralta, Santa Fe, NM 87501, USA",
      "poi_short_description": "Sweeping Santa Fe views from a hilltop park reached by a path lined with city history plaques.",
      "poi_long_description": "People say this park offers stunning views of the city, mountains, and sunset. They highlight the free access, the historical significance with plaques detailing major milestones, and the well-maintained paved path. They also like the opportunity for a hike and the option to climb the cross for an even higher vantage point. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-66f6-76fb-8cf3-db48ec29b1ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-66f6-76fb-8cf3-db48ec29b1ba",
        "storage_key": "property/6767906449167301/019d02d7-66f6-76fb-8cf3-db48ec29b1ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.santafenm.gov/district_1_parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=18313280607586912497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cross-of-the-martyrs",
      "poi_latitude": "35.6895016",
      "poi_longitude": "-105.9329236",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 505-955-6949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1002-710f-b101-9ebb20063df9",
        "storage_key": "property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbz8PPEhQGIcR8YhER6_XJf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9fefdc99-81c9-4e44-be23-99d05fafae71",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Fort Marcy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "490 Bishops Lodge Rd, Santa Fe, NM 87501, USA",
      "poi_short_description": "Park featuring a grassy baseball field, a playground and an outdoor gym, as well as a pool.",
      "poi_long_description": "People say this park offers trails for light hiking and is a place to let go of troubles. They highlight the large size, the views, and the opportunity to watch the burning of Zozobra. They also like the pickleball courts, baseball field, and play area for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-67e6-719e-b267-e8be0d1025f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-67e6-719e-b267-e8be0d1025f5",
        "storage_key": "property/6767906449167301/019d02d7-67e6-719e-b267-e8be0d1025f5.webp",
        "width": 1280,
        "height": 1216
      },
      "poi_business_url": "http://www.santafenm.gov/district_1_parks#leave-site-alert",
      "poi_directions_map_url": "https://maps.google.com/?cid=14867284429983074833&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-marcy-park",
      "poi_latitude": "35.69559479999999",
      "poi_longitude": "-105.9347458",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-955-2105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1002-710f-b101-9ebb20063df9",
        "storage_key": "property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4W5qjBQGIcREUrWN2s0U84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8023f429-d010-4ff2-ad1c-e2d3319c2849",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Dale Ball Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Santa Fe, NM 87501, USA",
      "poi_short_description": "Scenic 22-mi. network of mountain trails with a variety of terrain for hiking, running & biking.",
      "poi_long_description": "People say this hiking area offers well-marked trails with lovely scenery and many choices in terms of distance. They highlight the easy parking, shady spots, and the suitability for dogs and children. They also like the panoramic views of Santa Fe and the variety of plants and rocks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-68bd-74b9-8bc0-97cc81c5da60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-68bd-74b9-8bc0-97cc81c5da60",
        "storage_key": "property/6767906449167301/019d02d7-68bd-74b9-8bc0-97cc81c5da60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sfct.org/trails/dale-ball-trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=5589489984680474527&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dale-ball-trails",
      "poi_latitude": "35.6904031",
      "poi_longitude": "-105.8959241",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 505-955-6977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTIpq5VRGIcRn7d71IbbkU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_71e89753-9eb6-4eab-8add-136b77d5028c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Frank S Ortiz Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "160 Camino de Las Crucitas, Santa Fe, NM 87501, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this dog park offers a huge open space with lots of trails and beautiful views. They highlight the friendly dogs and conscious pet owners who clean up after their pets. They also like the benches for sitting and the availability of poop bags. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-6928-73aa-bce4-5885968cb258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-6928-73aa-bce4-5885968cb258",
        "storage_key": "property/6767906449167301/019d02d7-6928-73aa-bce4-5885968cb258.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thedogparkproject.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11877852888674540376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frank-s-ortiz-dog-park",
      "poi_latitude": "35.697351",
      "poi_longitude": "-105.963342",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-231-4920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1002-710f-b101-9ebb20063df9",
        "storage_key": "property/6767906449167301/019d02d7-1002-710f-b101-9ebb20063df9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7V4lQhQGIcRWBvLS0Wc1qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_d4cde9a6-ef99-4ae8-8a66-ebd296d44975",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe Depot Rail Runner Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Santa Fe, NM 87501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-eeb4-7231-92bd-0df25000b72e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-eeb4-7231-92bd-0df25000b72e",
        "storage_key": "property/6767906449167301/019d02d6-eeb4-7231-92bd-0df25000b72e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riometro.org/215/Santa-Fe-Depot",
      "poi_directions_map_url": "https://maps.google.com/?cid=2163755355907060352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santa-fe-depot-rail-runner-station",
      "poi_latitude": "35.6843236",
      "poi_longitude": "-105.9466563",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 866-795-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1507-7111-a06d-ba4c9c1c526c",
        "storage_key": "property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdQ6dWpQGIcRgHKwOQg0Bx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_1532d6d5-9d80-4f9f-9d0b-297db09bcb05",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "South Capitol Rail Runner Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1301 Alta Vista St, Santa Fe, NM 87502, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-edec-7417-b47e-bd2af3c34cd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-edec-7417-b47e-bd2af3c34cd0",
        "storage_key": "property/6767906449167301/019d02d6-edec-7417-b47e-bd2af3c34cd0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.riometro.org/218/South-Capitol",
      "poi_directions_map_url": "https://maps.google.com/?cid=16511397481157488320&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-capitol-rail-runner-station",
      "poi_latitude": "35.6731647",
      "poi_longitude": "-105.9572231",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 866-795-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1507-7111-a06d-ba4c9c1c526c",
        "storage_key": "property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJF790t2RQGIcRwO6rKYdEJOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ba5fd5a3-5b97-4877-b638-23c86ee60460",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Zia Road Rail Runner Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-e908-744a-a89c-a9ac90746adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-e908-744a-a89c-a9ac90746adb",
        "storage_key": "property/6767906449167301/019d02d6-e908-744a-a89c-a9ac90746adb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riometro.org/221/Zia-Road",
      "poi_directions_map_url": "https://maps.google.com/?cid=172769613672997671&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "zia-road-rail-runner-station",
      "poi_latitude": "35.646412",
      "poi_longitude": "-105.95701",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 866-795-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-1507-7111-a06d-ba4c9c1c526c",
        "storage_key": "property/6767906449167301/019d02d7-1507-7111-a06d-ba4c9c1c526c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4LjlpdQGIcRJ-P1WgzNZQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_06993cf2-0800-4561-a356-f7e6b27c9e6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "City of Santa Fe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Lincoln Ave, Santa Fe, NM 87501, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-6d58-7782-a7a1-e8b80970d170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-6d58-7782-a7a1-e8b80970d170",
        "storage_key": "property/6767906449167301/019d02d7-6d58-7782-a7a1-e8b80970d170.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.santafenm.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12372717371984597805&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-santa-fe",
      "poi_latitude": "35.6897585",
      "poi_longitude": "-105.9383958",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 505-955-6509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-18a7-7357-ae7b-befe24ff77e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-18a7-7357-ae7b-befe24ff77e8",
        "storage_key": "property/6767906449167301/019d02d7-18a7-7357-ae7b-befe24ff77e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_t_fEdQGIcRLVNyd-W4tKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_047033ea-7994-46a0-9a71-97b6d73db38d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Public Employee Retirement Association (PERA)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33 Plaza La Prensa, Santa Fe, NM 87507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nmpera.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14236605706602137373&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "public-employee-retirement-association-pera",
      "poi_latitude": "35.6074907",
      "poi_longitude": "-106.0401442",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 505-476-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWNtpGBZGIcRHcdRHXaVksU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5a11401c-9bdc-4998-9fe9-276b743ce97a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "LabCorp Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 Vivigen Way, Santa Fe, NM 87505, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.labcorp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2809341791768252082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "labcorp-corporate-office",
      "poi_latitude": "35.6373472",
      "poi_longitude": "-105.9608626",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 505-438-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyedgaRQGIcRso4Bn3nJ_CY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dfe3fe8a-4498-4cdf-bc69-c4d546eae7ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "PSI Testing Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4001 Office Ct Dr #301, Santa Fe, NM 87507, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509065977976795954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "psi-testing-center",
      "poi_latitude": "35.6328471",
      "poi_longitude": "-106.0156445",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJawMPXBJbGIcRMjMDeKKOWsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_77d56e00-a311-4eeb-8669-b40f5dd91878",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "BTI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33 Velocity Way, Santa Fe, NM 87508, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-6e29-7454-9636-0b8cf3d79911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d7-6e29-7454-9636-0b8cf3d79911",
        "storage_key": "property/6767906449167301/019d02d7-6e29-7454-9636-0b8cf3d79911.webp",
        "width": 1280,
        "height": 746
      },
      "poi_business_url": "http://www.bti-usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10387887633099854367&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bti",
      "poi_latitude": "35.6040746",
      "poi_longitude": "-106.0040647",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 505-473-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-09d5-747f-bcf0-d7f36ac30606",
        "storage_key": "property/6767906449167301/019d02d7-09d5-747f-bcf0-d7f36ac30606.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxT2YQ1laGIcRHxKX0cMwKZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6cb02905-61e4-4b8e-a63b-e3c115ccd43e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "E.J. Martinez Elementary School",
      "poi_type": "Education",
      "poi_address": "2451 Avenida Chaparral, Santa Fe, NM 87505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019f1ea7-9c55-701c-b644-66cc8cf9a0d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1ea7-9c55-701c-b644-66cc8cf9a0d5",
        "storage_key": "property/6767906449167301/019f1ea7-9c55-701c-b644-66cc8cf9a0d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://ejmartinez.sfps.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10760593863092353573&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ej-martinez-elementary-school",
      "poi_latitude": "35.643964",
      "poi_longitude": "-105.9671933",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 505-467-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLduZDVlQGIcRJTrePRtPVZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9d8a134e-d7c3-4693-ad03-eb57eb8643a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Milagro Middle School",
      "poi_type": "Education",
      "poi_address": "1720 Llano St, Santa Fe, NM 87505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://milagro.sfps.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11393459636157411163&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "milagro-middle-school",
      "poi_latitude": "35.6565723",
      "poi_longitude": "-105.9725746",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 505-467-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaSPb85VQGIcRW-_phyyzHZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eb372726-f7b2-44f7-bb2b-0864860a5be9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "poi_name": "Santa Fe High School",
      "poi_type": "Education",
      "poi_address": "2100 Yucca St, Santa Fe, NM 87505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019f1ea7-9c61-74d8-99b0-fdc6cef07ec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1ea7-9c61-74d8-99b0-fdc6cef07ec5",
        "storage_key": "property/6767906449167301/019f1ea7-9c61-74d8-99b0-fdc6cef07ec5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sfhs.sfps.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5075290924592440895&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "santa-fe-high-school",
      "poi_latitude": "35.6489329",
      "poi_longitude": "-105.9734123",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 505-467-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d7-0edc-7097-a2c3-6b4d04d9cf96",
        "storage_key": "property/6767906449167301/019d02d7-0edc-7097-a2c3-6b4d04d9cf96.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbcaBEXdaGIcRP6YYtDQOb0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "custom_5d8d3f03-3e1f-4b41-afdb-57ffcc89b064",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "rating": "5.0",
      "name": "Raf G",
      "text": "Thank you to Kayley for doing ur best with this place. Ur work dusnt go un knowticed you has helped me mor then the passed managers have thank you kayley and Montana for always being nice to me",
      "date": "2026-03-04",
      "title": ""
    },
    {
      "id": "custom_b44bdfb3-c901-4b80-ba98-cf6913bd0ea5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "rating": "5.0",
      "name": "Tara Michelle Pagan",
      "text": "$87.43/single room includes $10 pet fee. Very cute, very clean, no cigarette odor, very helpful people, free breakfast, great views, would stay again!",
      "date": "2017-11-04",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019d025b-e46b-7028-9a74-bb543827d072",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-santa-fe-suites",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-santa-fe",
      "search_query": "pet friendly apartments Santa Fe",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Santa Fe",
      "h2_subtitle": "Santa Fe Suites offers pet friendly apartments. Enjoy vibrant living near parks where your furry friends are welcome too.",
      "page_copy": "Discover the joys of living in a place where furry companions are more than welcome. Santa Fe Suites provides pet-friendly apartments in Santa Fe, offering a fabulous lifestyle for both you and your pets. Nestled in a neighborhood with beautiful parks within walking distance, you and your four-legged friend can enjoy the fresh air and vibrant community spaces whenever you please.\n\nOur beautifully designed studio and one-bedroom floor plans ensure plenty of space for you and your pet to relax and unwind. With amenities like a newly renovated grilling area and high-speed Wi-Fi, entertaining or simply relaxing at home has never been easier. Plus, the convenient location near Santa Fe Community College and Plaza Entrada Shopping allows for quick errands and more leisurely outings with your pet by your side. Discover how easy and enjoyable life can be at Santa Fe Suites.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Santa Fe",
      "seo_description": "Santa Fe Suites offers pet friendly apartments with modern amenities, ideal for you and your furry friend near downtown Santa Fe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-santa-fe-nm",
      "search_query": "air conditioned apartments in Santa Fe NM",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Santa Fe, NM",
      "h2_subtitle": "Experience comfort in air conditioned apartments at Santa Fe Suites. Enjoy a cool retreat in the vibrant heart of Santa Fe, NM.",
      "page_copy": "When seeking relief from the New Mexico heat, look no further than Santa Fe Suites. Our air conditioned apartments in Santa Fe, NM, ensure a cool and comfortable living environment year-round. Whether you're coming back from a day out at the nearby Plaza Entrada Shopping Center or relaxing after classes at Santa Fe Community College, our stylish studio and one-bedroom floor plans provide the perfect retreat.\n\nSanta Fe Suites isn’t just about keeping cool; we feature amenities designed to elevate your living experience. Picture yourself enjoying the fresh air while grilling at our newly renovated outdoor space or staying connected with friends and family through our free high-speed Wi-Fi. Plus, being steps away from scenic parks, you can catch a breath of fresh air whenever it's needed. Embrace a perfect blend of comfort and convenience at Santa Fe Suites, where air conditioning is just the beginning.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Santa Fe, NM",
      "seo_description": "Stay cool and comfortable at Santa Fe Suites with air conditioned apartments, near shops and parks for an ideal NM lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "stainless-steel-apartments-santa-fe-county",
      "search_query": "apartments with stainless steel appliances Santa Fe County",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover modern living in Santa Fe County with apartments featuring stainless steel appliances, designed for style and efficiency.",
      "page_copy": "Experience contemporary living with Santa Fe Suites, where our apartments boast premium stainless steel appliances. Located in the heart of Santa Fe County, our modern kitchens cater to your culinary needs, offering a sleek and efficient environment perfect for both amateur and professional cooks. Embrace the convenience and beauty of these high-quality finishes that complement our stylish studio and one-bedroom layouts.\n\nIn addition to top-of-the-line kitchens, indulge in a suite of amenities including a newly renovated grilling area perfect for gatherings, and complimentary high-speed Wi-Fi to ensure you remain connected. With a prime location just minutes away from Plaza Entrada Shopping and local parks, Santa Fe Suites offers a vibrant lifestyle enhanced by the best of modern conveniences. Discover an elevated standard of living in our thoughtfully designed community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances",
      "seo_description": "Find apartments with stainless steel appliances in Santa Fe County. Santa Fe Suites offers modern comfort with sleek kitchen amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "high-speed-internet-apartments-santa-fe-87505",
      "search_query": "high speed internet apartments Santa Fe 87505",
      "category": "Amenity",
      "h1_title": "High Speed Internet Apartments in Santa Fe",
      "h2_subtitle": "Stay connected with high speed internet at Santa Fe Suites. Located in the 87505 area, enjoy seamless online experiences at home.",
      "page_copy": "In today’s connected world, having reliable high speed internet is essential, and Santa Fe Suites delivers just that in Santa Fe, 87505. Our apartments are equipped with free high-speed Wi-Fi, making sure you enjoy seamless connectivity whether working from home, streaming your favorite shows, or connecting with loved ones. Our internet-ready studio and one-bedroom apartments provide the optimal environment for modern living.\n\nResidents of Santa Fe Suites not only benefit from robust internet connectivity but also from our community-focused amenities. Take advantage of the newly renovated grilling area or unwind in nearby scenic parks. Situated conveniently close to Plaza Entrada Shopping and Santa Fe Community College, our location allows effortless access to shopping, dining, and educational opportunities. Experience worry-free living while staying connected in the heart of Santa Fe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High Speed Internet Apartments in Santa Fe",
      "seo_description": "Enjoy high speed internet at Santa Fe Suites, located in Santa Fe, 87505. Perfect for work, streaming, and staying connected.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "gated-community-apartments-santa-fe-nm",
      "search_query": "gated community apartments in Santa Fe NM",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Santa Fe, NM",
      "h2_subtitle": "Discover the security and peace of mind offered by gated community apartments at Santa Fe Suites, where comfort meets convenience in Santa Fe, NM.",
      "page_copy": "Santa Fe Suites provides an ideal blend of security and modern living with our gated community apartments in Santa Fe, NM. Our community offers a serene environment where residents can relax and feel secure, knowing that their home is nestled in a safe and welcoming neighborhood. Our floor plans range from cozy studios to spacious one-bedroom apartments, all designed with your comfort in mind.\n\nBeyond the gates, enjoy an array of amenities that cater to a vibrant lifestyle. Grill with friends in our newly renovated picnic area, or stay connected with complimentary high-speed Wi-Fi. Located conveniently near the Plaza Entrada Shopping Center and surrounded by local green spaces, Santa Fe Suites is your retreat within the city. Experience a community where security, style, and serenity meet, right here in Santa Fe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Santa Fe, NM",
      "seo_description": "Live securely in Santa Fe Suites, a gated community apartment complex in Santa Fe, NM. Enjoy peace and convenience in a beautiful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "studio-apartments-santa-fe-nm",
      "search_query": "studio apartments Santa Fe NM",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Santa Fe, NM",
      "h2_subtitle": "Explore stylish studio apartments at Santa Fe Suites in NM. Experience modern amenities and a vibrant community in Santa Fe.",
      "page_copy": "At Santa Fe Suites, find your perfect studio apartment in Santa Fe, NM, where style and comfort are perfectly intertwined. Our thoughtfully designed studio layouts are ideal for anyone seeking a blend of efficient living spaces and modern aesthetics. Benefit from contemporary features, including stainless steel appliances and free high-speed Wi-Fi, making your everyday life convenient and enjoyable.\n\nLiving at Santa Fe Suites means you're part of a vibrant community situated near Plaza Entrada Shopping and local attractions. Enjoy access to our newly renovated grilling space perfect for relaxing afternoons, or engage with nature at nearby parks. Whether you're a student at Santa Fe Community College or a professional seeking an easy commute, our strategic location and amenities provide everything you need to simplify your lifestyle. Discover how our studio apartments can be the ideal backdrop for the life you love in Santa Fe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Santa Fe, NM",
      "seo_description": "Find stylish studio apartments in Santa Fe, NM, at Santa Fe Suites. Enjoy modern amenities and a vibrant community in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-santa-fe-county",
      "search_query": "one bedroom apartments Santa Fe County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Santa Fe County",
      "h2_subtitle": "Discover comfortable one-bedroom apartments at Santa Fe Suites in Santa Fe County, perfect for modern living with easy access to local amenities.",
      "page_copy": "Santa Fe Suites offers inviting one-bedroom apartments in the heart of Santa Fe County, designed to accommodate your modern lifestyle. Our spacious one-bedroom layouts provide a sanctuary where you can unwind after a busy day, complete with amenities like water-efficient plumbing and free high-speed Wi-Fi to enhance your living experience.\n\nCentrally located, our community makes it easy to access Santa Fe County’s best shopping at Plaza Entrada, dining, and recreation options just a short walk away. Take advantage of our newly renovated picnic and grilling area, or explore local green spaces for a refreshing escape into nature. Whether you're a professional looking for convenience or someone who values community, Santa Fe Suites is the ideal place to call home in Santa Fe County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Santa Fe County",
      "seo_description": "Explore one-bedroom apartments at Santa Fe Suites in Santa Fe County. Modern amenities with easy access to shopping and dining.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "apartments-near-carlos-gilbert-elementary-school-santa-fe",
      "search_query": "apartments near Carlos Gilbert Elementary School Santa Fe",
      "category": "School",
      "h1_title": "Apartments Near Carlos Gilbert Elementary School",
      "h2_subtitle": "Find family-friendly apartments conveniently located near Carlos Gilbert Elementary School in Santa Fe, offering modern living and amenities.",
      "page_copy": "Santa Fe Suites presents a perfect option for families seeking apartments near Carlos Gilbert Elementary School in Santa Fe. Our community is designed with families in mind, offering comfortable living spaces with choices of studio and one-bedroom layouts that accommodate various needs. Enjoy the convenience of living close to one of Santa Fe’s reputable schools while benefiting from the modern amenities our property has to offer.\n\nWelcoming you with a friendly atmosphere, Santa Fe Suites provides residents with amenities such as a newly renovated grilling area and easily accessible shopping at Plaza Entrada. Located just steps away from essential local services and recreational areas, our ideal location enhances daily life. Whether you're planning family outings or educational pursuits, our proximity to Carlos Gilbert Elementary School makes it easier and more convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Carlos Gilbert Elementary School",
      "seo_description": "Discover family-friendly apartments at Santa Fe Suites near Carlos Gilbert Elementary in Santa Fe, featuring modern amenities and convenient access to local services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "santa-fe-high-school-nearby-apartments",
      "search_query": "Santa Fe High School nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Santa Fe High School",
      "h2_subtitle": "Explore convenient living in apartments located near Santa Fe High School, offering easy access to education and community conveniences.",
      "page_copy": "Santa Fe Suites is the ideal choice for those searching for apartments nearby Santa Fe High School. Our community provides a range of studio and one-bedroom floor plans designed to offer both comfort and style for students and families alike. With contemporary amenities like free high-speed Wi-Fi and a newly renovated grilling space, you can enjoy a balanced lifestyle in a supportive environment.\n\nConveniently situated in Santa Fe, our location ensures a short commute to Santa Fe High School, as well as access to local parks, such as those near Plaza Entrada Shopping, which is only a two-minute walk away. The prime location ensures quick access to both educational opportunities and leisure activities. Discover how Santa Fe Suites can cater to your living needs while keeping you close to educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Santa Fe High School",
      "seo_description": "Find comfortable living at Santa Fe Suites with nearby access to Santa Fe High School, enjoying modern amenities and community conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "st-michaels-high-school-santa-fe-living",
      "search_query": "St. Michael's High School Santa Fe living",
      "category": "School",
      "h1_title": "Living Near St. Michael's High School",
      "h2_subtitle": "Experience convenient living near St. Michael's High School in Santa Fe, with modern amenities and community-centric living at Santa Fe Suites.",
      "page_copy": "At Santa Fe Suites, enjoy a comfortable lifestyle in close proximity to St. Michael's High School in Santa Fe. Our community features a selection of stylish studio and one-bedroom apartments that are perfect for families and individuals who value accessibility and convenience. With amenities like water-efficient plumbing and a picnic area, Santa Fe Suites supports a sustainable and community-driven way of living.\n\nLocated strategically in Santa Fe, our property offers easy access to educational institutions like St. Michael's High School, alongside nearby shopping centers such as Plaza Entrada. This ensures that residents can enjoy a balanced life with both academic and recreational activities just around the corner. Choose Santa Fe Suites for a home that provides the ideal blend of comfort, location, and modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near St. Michael's High School",
      "seo_description": "Santa Fe Suites offers modern living near St. Michael's High School, featuring convenient access and community-focused amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "find-apartments-near-santa-fe-indian-school",
      "search_query": "find apartments near Santa Fe Indian School",
      "category": "School",
      "h1_title": "Find Apartments Near Santa Fe Indian School",
      "h2_subtitle": "Discover the perfect home near Santa Fe Indian School with Santa Fe Suites, offering modern features and a prime location.",
      "page_copy": "Santa Fe Suites offers an excellent choice for those looking to find apartments near Santa Fe Indian School. Our community features well-designed studio and one-bedroom apartments that provide a comfortable living experience complete with modern amenities like high-speed Wi-Fi and a newly upgraded grilling area. Enjoy a home that supports your active lifestyle and educational commitments.\n\nPositioned in a prime Santa Fe location, Santa Fe Suites ensures that you have quick and convenient access to Santa Fe Indian School. Additionally, amenities like the nearby Plaza Entrada Shopping and Santa Fe Community College enrich the neighborhood experience. Embrace a vibrant lifestyle with everything you need just steps away, making Santa Fe Suites the perfect place for students, educators, and families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Santa Fe Indian School",
      "seo_description": "Explore Santa Fe Suites for modern living near Santa Fe Indian School, featuring convenient amenities and easy access to local services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "santa-fe-preparatory-school-close-by-accommodations",
      "search_query": "Santa Fe Preparatory School close by accommodations",
      "category": "School",
      "h1_title": "Accommodations Near Santa Fe Preparatory School",
      "h2_subtitle": "Discover convenient accommodations close to Santa Fe Preparatory School with Santa Fe Suites, offering modern living solutions.",
      "page_copy": "Santa Fe Suites is home to the best close-by accommodations for those attending or working at Santa Fe Preparatory School. Our community offers studio and one-bedroom apartments designed for comfort, featuring amenities like free high-speed Wi-Fi and newly renovated grilling spaces for an enhanced living experience. Enjoy a home tailored to support both academic pursuits and relaxation.\n\nLocated in the heart of Santa Fe, Santa Fe Suites provides easy access to Santa Fe Preparatory School alongside nearby conveniences like Plaza Entrada Shopping and local parks. Make the most of a strategic location that supports education and leisure activities alike. Choose Santa Fe Suites as your ideal residence for a well-rounded and community-focused lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accommodations Near Santa Fe Preparatory School",
      "seo_description": "Find modern living at Santa Fe Suites with accommodations close to Santa Fe Preparatory School, equipped with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "st-johns-college-santa-fe-apartments",
      "search_query": "St. John's College Santa Fe apartments",
      "category": "School",
      "h1_title": "Apartments Near St. John's College, Santa Fe",
      "h2_subtitle": "Explore convenient Santa Fe apartments near St. John's College at Santa Fe Suites, perfect for students and staff.",
      "page_copy": "Santa Fe Suites offers an ideal living solution with apartments near St. John's College in Santa Fe. Our studio and one-bedroom floor plans are designed to accommodate students and faculty alike, combining comfort with functionality. Take advantage of amenities such as a modern picnic area and complimentary high-speed Wi-Fi, ensuring you have everything needed for a balanced lifestyle.\n\nLocated in vibrant Santa Fe, our community offers easy access not only to St. John's College but also to amenities like the nearby Plaza Entrada Shopping and Santa Fe Community College. This makes Santa Fe Suites a convenient choice for those who value both educational and recreational opportunities. Enjoy a welcoming and supportive community atmosphere at Santa Fe Suites.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. John's College, Santa Fe",
      "seo_description": "Discover Santa Fe Suites for comfortable apartments near St. John's College, featuring essential amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "santa-fe-community-college-student-housing-options",
      "search_query": "Santa Fe Community College student housing options",
      "category": "School",
      "h1_title": "Santa Fe Community College Student Housing",
      "h2_subtitle": "Explore ideal student housing options near Santa Fe Community College at Santa Fe Suites, where convenience meets comfort.",
      "page_copy": "Santa Fe Suites offers the perfect student housing options for those attending Santa Fe Community College. Our stylish studio and one-bedroom apartments are designed with students in mind, featuring modern amenities like high-speed internet and a newly renovated grilling area. These features provide the right balance of comfort and functionality essential for student life.\n\nConveniently located near Santa Fe Community College, Santa Fe Suites ensures easy commuting while providing access to local attractions, including Plaza Entrada Shopping and scenic parks. Enjoy a vibrant community that supports both academic goals and leisure activities, making Santa Fe Suites the ideal choice for college students looking for a welcoming and dynamic living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Santa Fe Community College Student Housing",
      "seo_description": "Discover student housing options at Santa Fe Suites, perfect for Santa Fe Community College attendees, with modern amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "apartments-near-christus-st-vincent-regional-medical-center",
      "search_query": "apartments near CHRISTUS St. Vincent Regional Medical Center Santa Fe",
      "category": "Hospital",
      "h1_title": "Apartments Near CHRISTUS St. Vincent Medical",
      "h2_subtitle": "Find the perfect home near CHRISTUS St. Vincent Regional Medical Center at Santa Fe Suites, offering convenient living solutions.",
      "page_copy": "Santa Fe Suites provides exceptional apartment living near CHRISTUS St. Vincent Regional Medical Center in Santa Fe, ideal for healthcare professionals and hospital visitors seeking nearby accommodations. Our community features comfortable studio and one-bedroom floor plans, complemented by amenities like water-efficient plumbing and free high-speed Wi-Fi, ensuring a modern and efficient lifestyle.\n\nLocated in the heart of Santa Fe, Santa Fe Suites is just a short distance from the medical center and provides easy access to local highlights such as Plaza Entrada Shopping and educational institutions like Santa Fe Community College. Whether you're working or recovering, our community offers a supportive environment with everything you need close at hand, making it an excellent choice for anyone connected to CHRISTUS St. Vincent.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near CHRISTUS St. Vincent Medical",
      "seo_description": "Explore Santa Fe Suites for apartments near CHRISTUS St. Vincent Regional Medical Center, equipped with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "apartments-near-salvador-perez-park-santa-fe",
      "search_query": "apartments near Salvador Perez Park Santa Fe",
      "category": "Park",
      "h1_title": "Apartments Near Salvador Perez Park, Santa Fe",
      "h2_subtitle": "Discover your ideal home at Santa Fe Suites, conveniently located near Salvador Perez Park in Santa Fe.",
      "page_copy": "Located just a short distance from Salvador Perez Park, Santa Fe Suites offers comfortable and stylish apartment living in Santa Fe. Choose from our well-appointed studio and one-bedroom apartments, perfect for those who enjoy an active lifestyle with quick access to park facilities.\n\nSanta Fe Suites not only provides close proximity to Salvador Perez Park but also includes community perks such as a renovated grilling area and wireless internet access. Additionally, our location offers easy access to the vibrant Santa Fe culture, including the nearby Plaza Entrada Shopping center and other local amenities. Make the most of outdoor activities and recreational opportunities while enjoying a welcoming community at Santa Fe Suites.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Salvador Perez Park, Santa Fe",
      "seo_description": "Find your home at Santa Fe Suites, close to Salvador Perez Park, with modern amenities and a prime location offering an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "apartments-close-to-villa-linda-park",
      "search_query": "apartments close to Villa Linda Park",
      "category": "Park",
      "h1_title": "Apartments Close to Villa Linda Park",
      "h2_subtitle": "Discover Santa Fe Suites, offering ideal apartments close to Villa Linda Park, perfect for those who enjoy nature and convenience.",
      "page_copy": "Santa Fe Suites is proud to offer superior apartment living close to the scenic Villa Linda Park. Our selection of stylish studio and one-bedroom options is perfect for those who enjoy outdoor spaces and require modern conveniences. Enjoy features like high-speed Wi-Fi and a newly renovated grilling area, providing a perfect blend of comfort and functionality.\n\nWith Villa Linda Park just moments away, residents can indulge in a variety of outdoor activities and recreational pursuits. Additionally, Santa Fe Suites offers convenient access to local attractions, including Plaza Entrada Shopping and the nearby Santa Fe Community College. Experience a community that supports both relaxation and excitement, right at the heart of what Santa Fe has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Villa Linda Park",
      "seo_description": "Discover Santa Fe Suites' convenient apartments, just moments from Villa Linda Park, with modern amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "santa-fe-railyard-park-nearby-apartments",
      "search_query": "Santa Fe Railyard Park nearby apartments",
      "category": "Park",
      "h1_title": "Santa Fe Railyard Park Nearby Apartments",
      "h2_subtitle": "Live at Santa Fe Suites with Santa Fe Railyard Park nearby, offering a vibrant location coupled with modern amenities.",
      "page_copy": "Santa Fe Suites provides the ideal living situation for those seeking apartments near Santa Fe Railyard Park. Our studio and one-bedroom homes are designed with modern comforts in mind, featuring amenities like newly renovated grilling spaces and high-speed Wi-Fi to enhance your lifestyle. This prime location is perfect for anyone looking to enjoy the dynamic environment of the nearby Railyard Park.\n\nLiving close to Santa Fe Railyard Park means you can easily explore the vibrant culture and amenities of this lively community space. Santa Fe Suites also offers proximity to other local conveniences such as Plaza Entrada Shopping and Santa Fe Community College, ensuring you are never far from what you need. Choose Santa Fe Suites for a home that blends accessibility with comfort and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Santa Fe Railyard Park Nearby Apartments",
      "seo_description": "Explore Santa Fe Suites for modern apartments near Santa Fe Railyard Park, offering a prime location and community-focused amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "de-vargas-park-nearby-rental-apartments",
      "search_query": "De Vargas Park nearby rental apartments",
      "category": "Park",
      "h1_title": "De Vargas Park Nearby Rental Apartments",
      "h2_subtitle": "Find your new home at Santa Fe Suites, offering rental apartments conveniently located near De Vargas Park.",
      "page_copy": "Santa Fe Suites is the perfect choice for those seeking rental apartments near De Vargas Park. Our spacious studio and one-bedroom options provide a comfortable living experience, complete with modern amenities like a newly renovated grilling area and high-speed Wi-Fi, catering to all your daily needs.\n\nSituated close to the lush De Vargas Park, Santa Fe Suites gives residents easy access to outdoor leisure and recreational activities. Enjoy the tranquility of the park just minutes from your doorstep, while also benefiting from proximity to local spots like Plaza Entrada Shopping and Santa Fe Community College. Embrace a lifestyle that balances relaxation and excitement at Santa Fe Suites.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "De Vargas Park Nearby Rental Apartments",
      "seo_description": "Discover Santa Fe Suites for rental apartments near De Vargas Park, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "santa-fe-nm-apartments-near-amelia-white-park",
      "search_query": "Santa Fe NM apartments near Amelia White Park",
      "category": "Park",
      "h1_title": "Santa Fe NM Apartments Near Amelia White Park",
      "h2_subtitle": "Experience the ideal living at Santa Fe Suites, offering apartments near Amelia White Park, equipped with modern conveniences.",
      "page_copy": "Santa Fe Suites offers exceptional apartment living for those seeking residences near Amelia White Park in Santa Fe, NM. Our thoughtfully designed studio and one-bedroom apartments feature amenities like high-speed Wi-Fi and a beautifully renovated grilling area, ensuring a charming and efficient home environment. \n\nBeing close to Amelia White Park, residents at Santa Fe Suites can enjoy easy access to lush green spaces and leisure activities. Complementing this tranquil location, our community is conveniently near Plaza Entrada Shopping and Santa Fe Community College, making it easy to balance nature and city life. Choose Santa Fe Suites for a harmonious blend of comfort, convenience, and connectivity in Santa Fe, NM.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Santa Fe NM Apartments Near Amelia White Park",
      "seo_description": "Explore Santa Fe Suites, offering modern apartments in Santa Fe, NM near Amelia White Park, with convenient amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167301",
      "source": "custom",
      "page_item_url": "apartments-close-to-santa-fe-botanical-garden",
      "search_query": "apartments close to Santa Fe Botanical Garden",
      "category": "Park",
      "h1_title": "Apartments Close to Santa Fe Botanical Garden",
      "h2_subtitle": "Discover Santa Fe Suites, offering comfortable living with apartments conveniently close to the Santa Fe Botanical Garden.",
      "page_copy": "Santa Fe Suites is the perfect community if you're looking for apartments close to Santa Fe Botanical Garden. Our stylish studio and one-bedroom apartments are equipped with modern amenities such as renovated grilling spaces and high-speed Wi-Fi, ensuring a fulfilling living experience.\n\nLiving at Santa Fe Suites, you'll have easy access to the vibrant natural beauty of the Santa Fe Botanical Garden, perfect for nature lovers and outdoor enthusiasts. Besides the serene surroundings, our community is strategically located near Plaza Entrada Shopping and Santa Fe Community College, providing a balanced lifestyle of convenience and relaxation. Embrace the opportunity to live in a well-situated home tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with stucco walls and orange trim.",
        "public_id": "019d02d6-7d87-7659-a943-558f2e28e92d",
        "storage_key": "property/6767906449167301/019d02d6-7d87-7659-a943-558f2e28e92d.webp",
        "width": 1280,
        "height": 854
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Santa Fe Botanical Garden",
      "seo_description": "Find your ideal home at Santa Fe Suites, with apartments close to Santa Fe Botanical Garden, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5998"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11415715210"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PVCWG4NZ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "273SFS"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52457036062"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "20793"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imd6WnFtMFZESlYzTFV6Y2xEbEpnWXc9PSIsInZhbHVlIjoibFhuRXVZNk9jUXdtV1RoZ3JQbUNkUT09IiwibWFjIjoiMmI0NzFlNzM3MzRhNzYwNjdiZWRjZjcyNjZlYmI0YjEwM2QwMjU4MzQzYmI3OTY3ZDU1OTRhMzRiY2ViMmUzNyJ9"
    }
  ],
  "custom_qb_id": "5998",
  "custom_repli_id": "11415715210",
  "custom_google_gtm_id": "GTM-PVCWG4NZ",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "273SFS",
  "custom_hubspot_company_id": "52457036062",
  "custom_broker_license_number": "20793",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imd6WnFtMFZESlYzTFV6Y2xEbEpnWXc9PSIsInZhbHVlIjoibFhuRXVZNk9jUXdtV1RoZ3JQbUNkUT09IiwibWFjIjoiMmI0NzFlNzM3MzRhNzYwNjdiZWRjZjcyNjZlYmI0YjEwM2QwMjU4MzQzYmI3OTY3ZDU1OTRhMzRiY2ViMmUzNyJ9",
  "custom_audioeye_site_id": "10a2a290-3d92-493b-b1a5-8f632f4d26b3",
  "custom_audioeye_site_hash": "892013db1fdc4781c2fdfd82afba0314"
};

export const generatedAt = '2026-10-05T17:25:07.347Z';
